import React from 'react';
import styles from './PageHeader.module.css';

const PageHeader = ({ title, subtitle, actions, children, className = '' }) => (
  <header className={`${styles.header} ${className}`.trim()}>
    <div className={styles.titleRow}>
      <div className={styles.titleBlock}>
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
      </div>
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
    {children}
  </header>
);

export default PageHeader;
